/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deceased_Badge_TitleInputs */



/**
* | output |
* | --- |
* | "This member is recorded as deceased" |
*
* @param {Deceased_Badge_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deceased_badge_title = /** @type {((inputs?: Deceased_Badge_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deceased_Badge_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce membre est enregistré comme décédé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este miembro está registrado como fallecido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este membro está registrado como falecido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo membro è registrato come deceduto")
	return /** @type {LocalizedString} */ ("This member is recorded as deceased")
});